import React, { useEffect, useState } from 'react'
import {
  Button, CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Menu,
  MenuItem,
  Typography
} from '@material-ui/core'
import { MoreVert } from '@material-ui/icons'
import { connect } from 'react-redux'
import actions from '../../reducers/actions'


const MoreOptions = ({ row, deleteTimesheet, user }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  
  useEffect(() => {
    setShowDeleteModal(false)
    setError(null)
    setLoading(false)
  }, [anchorEl])
  
  const handleClick = e => setAnchorEl(e.currentTarget)
  const handleShowDeleteModal = () => setShowDeleteModal(true)
  const handleHideDeleteModal = () => setShowDeleteModal(false)
  const handleDelete = () => {
    setLoading(false)
    setError(null)
    deleteTimesheet(user, row.TimeSheetID)
      .then(() => {
        handleHideDeleteModal()
        setAnchorEl(null)
      })
      .catch(() => setError('There was an error deleting this time sheet'))
      .finally(() => setLoading(false))
  }
  
  return (
    <div>
      <IconButton onClick={handleClick}>
        <MoreVert/>
      </IconButton>
      
      <Menu
        keepMounted
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem onClick={handleShowDeleteModal} style={{ color: 'red' }}>
          Delete
        </MenuItem>
      </Menu>
      
      <Dialog
        open={showDeleteModal}
        onClose={handleHideDeleteModal}
      
      >
        <DialogTitle id="alert-dialog-title">Delete Time Sheet</DialogTitle>
        
        <DialogContent>
          <Typography>
            This will <span style={{ fontWeight: 'bold' }}>COMPLETELY AND IRREVERSIBLY</span> delete this time sheet. Are you sure you want to?
          </Typography>
          
          {error && (
            <Typography style={{ color: 'red' }}>
              {error}
            </Typography>
          )}
        </DialogContent>
        
        <DialogActions>
          <Button onClick={handleHideDeleteModal}>Cancel</Button>
          {loading ? (
            <CircularProgress/>
          ) : (
            <Button onClick={handleDelete} autoFocus style={{ backgroundColor: 'red', color: 'white' }}>Delete</Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  )
}

const mapStateToProps = ({ user, deleteTimeSheet }, ownProps) => {
  return { user, deleteTimeSheet, ...ownProps }
}

export default connect(mapStateToProps, actions)(MoreOptions)